import Vue from 'vue';
import * as d3 from 'd3';
import * as SPURS from '../../../SPURS.config.js'; // get config


import CalculatePreviewDensity from '../../util/density/CalculatePreviewDensity';



const truncateMatrixAndCalcPreviewDensity = (matrix) => {

  /* 
    This function does the following:
    (1) truncate the matrix of values to the maximum used in the preview
    (2) call the preview density function
    (3) check the return path if it can be shown or not (and requires some additional information)
  */

  /**********************************************************************************
    [X.1] Downsampling
    --------------------
    At this stage, we potentially downsample.
    If the user has selected, let's say, 1 mio samples, not all of these
    samples are needed to show previews of the density distributions.
    Nor do we need all samples to calculate the KL divergence.
    The maximum number of samples is defined in the SPURS.config.
    We resample from the value array.
    Since the order is random already, we can just take the first up to X values.
  ***********************************************************************************/

  let result;

  let matrixTruncatedForPreview = [];
  for (let period = 0; period < matrix.length; period++){
    // For each period,
    // we only get at most the maxNumberOfSamplesUsedInPreviewAndForKLDivergence of samples

    let maxIndex = Math.min(matrix[period].length, SPURS.maxNumberOfSamplesUsedInPreviewAndForKLDivergence)
    matrixTruncatedForPreview.push(matrix[period].slice(0, maxIndex));
  }

  // Get the line for the array values of the selected period
  let previewResult = CalculatePreviewDensity(matrixTruncatedForPreview[Vue.prototype.$globalSharedData.selectedPeriod]);
  let density = previewResult.density;
  let yDensity = previewResult.yDensity;
  
  let line_pathvalues = d3.line()(density);
  // console.log('line', line_pathvalues)

  // Check if the pathvalues are OK     
  // Path information is a string and starts with an 'M'
  // After that, the first point should be provided
  // If the first 3 characters after the 'M' are NaN, we did not receive valid path information
  let canPreviewBeShown;
  let previewMessage;

  if (line_pathvalues.substring(1, 4) == 'NaN'){
    canPreviewBeShown = false;
    previewMessage = "<tspan x=\"50%\" y=\"50%\">Enter parameters above</tspan><tspan x=\"50%\" y=\"60%\">to see preview here</tspan>"
  } else if (line_pathvalues == 'M70,50L70,50L70,50L70,50L70,50'){
    // This case occurs if the triangle or square distribution have identical input parameters
    canPreviewBeShown = false;
    previewMessage = "<tspan x=\"50%\" y=\"50%\">Preview not visible</tspan><tspan x=\"50%\" y=\"60%\">(E.g. single value)</tspan>"
  } else {
    canPreviewBeShown = true;
  }

  result = {
    density: density,
    yDensity: yDensity,
    pathvalues: line_pathvalues,
    canPreviewBeShown: canPreviewBeShown,
    previewMessage: previewMessage,
    matrixTruncatedForPreview: matrixTruncatedForPreview,
  }
  
  return result;

}

export default truncateMatrixAndCalcPreviewDensity;